"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const next_i18next_1 = require("next-i18next");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_buttons_1 = require("@hotelplan/components.common.buttons");
const libs_hooks_react_1 = require("@hotelplan/libs.hooks-react");
const ForgotPasswordModal_1 = __importDefault(require("./ForgotPasswordModal"));
const ForgotPasswordLinkWrap = (0, styled_components_1.default)(components_common_buttons_1.Button)(({ theme }) => theme.buttons.linkBtn);
const ForgotPasswordLink = () => {
    const [t] = (0, next_i18next_1.useTranslation)(['forms', 'myaccount']);
    const [isShown, show, hide] = (0, libs_hooks_react_1.useToggleState)(false);
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(ForgotPasswordLinkWrap, { onClick: show }, t('forms:forgotPassword')),
        react_1.default.createElement(ForgotPasswordModal_1.default, { isShown: isShown, onClose: hide })));
};
exports.default = ForgotPasswordLink;
//# sourceMappingURL=ForgotPasswordLink.js.map